import { render, staticRenderFns } from "./Outdoor.vue?vue&type=template&id=52ef5b5e&"
import script from "./Outdoor.vue?vue&type=script&lang=ts&"
export * from "./Outdoor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports